import api from './axios'; 

var endpoint = 'customer'

function sanitizeCustomerPayload(form = {}) {
    const payload = { ...form }
    delete payload.created_by
    delete payload.updated_by
    delete payload.org_id
    if (typeof payload.preferred_language === 'string' && !payload.preferred_language.trim()) {
        payload.preferred_language = null
    }
    return payload
}

const customerRequests = {
    getAll(){
        return api.get(`/${endpoint}`)
    },
    save(form){
        return api.post(`/${endpoint}`, sanitizeCustomerPayload(form))
    },
    update(id,form){
        return api.patch(`/${endpoint}/${id}`, sanitizeCustomerPayload(form))
    },
    delete(id){
        return api.delete(`/${endpoint}/${id}`)
    }
};

export default customerRequests;
